'use strict';

import * as cookie from 'browser-cookies';

export class init {
    constructor(opt) {
        this.opt = opt;
        this.bindHandlers();
    }

    bindHandlers() {
        let _self = this;

        $('.add-vacancy-to-compare').click(function () {
            let btn = $(this);

            let div = btn.find('div.add');
            let vacancyId = btn.attr('data-vacancy-id');
            let vacancyCompare = cookie.get('vacancy_compare');

            if (div.length == 1) {

                div.removeClass('add').addClass('added');
                if (null === vacancyCompare) {
                    cookie.set('vacancy_compare', vacancyId, {expires: 7});
                } else {
                    let vacancyIdArr = vacancyCompare.split(',');

                    if (vacancyIdArr.length < 3) {
                        vacancyIdArr.push(vacancyId);
                        let cookieValStr = vacancyIdArr.join(',');
                        cookie.set('vacancy_compare', cookieValStr, {expires: 7});

                        if (vacancyIdArr.length === 3) {
                            $(document).find('button.add-vacancy-to-compare div.add').addClass('disabled')
                                .find('img').attr('src', btn.attr('data-disabled-icon')).parents('button')
                                .attr('disabled', true);
                        }
                    }
                }


                _self.showCompareIcon();
            } else {
                _self.removeFromCompare(vacancyCompare, vacancyId, btn);
            }
        });

        $('.remove-vacancy-from-compare').click(function () {
            $('a.add-vacansy').removeClass('disabled').attr('href', $('a.add-vacansy').attr('data-path'));
            let vacancyId = $(this).attr('data-vacancy-id');
            $('.vacancy-compare-' + vacancyId).remove();

            let vacancyCompare = cookie.get('vacancy_compare');
            _self.removeFromCompare(vacancyCompare, vacancyId);

            if (null === cookie.get('vacancy_compare')) {
                window.open(_self.opt.homepage, '_self');
            }
        });
    }

    removeFromCompare(vacancyCompareArr, vacancyId, btn) {
        let _self = this;

        let vacancyIdArr = vacancyCompareArr.split(',');

        if (vacancyIdArr.length === 1) {
            cookie.erase('vacancy_compare');
            _self.hideCompareIcon();
        } else {
            vacancyIdArr.splice($.inArray(vacancyId, vacancyIdArr), 1);
            let cookieValStr = vacancyIdArr.join(',');
            cookie.set('vacancy_compare', cookieValStr, {expires: 7});

            $('div.compare-wrap').find('span.notifications').text(vacancyIdArr.length);
        }

        if (typeof btn === "undefined") {
            return;
        }

        let div = btn.find('div.added');
        div.removeClass('added').addClass('add');

        $(document).find('button.add-vacancy-to-compare div.disabled').removeClass('disabled').removeClass('added').addClass('add')
            .find('img').attr('src', btn.attr('data-icon'));
        $(document).find('button.add-vacancy-to-compare').attr('disabled', false);
    }

    showCompareIcon() {
        let vacancyCompare = cookie.get('vacancy_compare');
        let vacancyIdArr = vacancyCompare.split(',');
        $('div.compare-wrap').css('display', 'flex').find('span.notifications').text(vacancyIdArr.length);
    }

    hideCompareIcon() {
        $('div.compare-wrap').hide();
    }
}